//Reference: https://www.positronx.io/full-angular-firebase-authentication-system/

import { Component, OnInit } from '@angular/core';
import { AuthService } from "../_services/authentication.service";
@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent implements OnInit {
  constructor(
    public authService: AuthService
  ) { }
  ngOnInit() { }
}